import React, { createContext, useContext, useState, useEffect } from 'react';

const PropFirmContext = createContext();

export const usePropFirm = () => useContext(PropFirmContext);

export const PropFirmProvider = ({ children }) => {
    const loadState = () => {
        try {
            const saved = localStorage.getItem('prop_firm_settings_v2');
            return saved ? JSON.parse(saved) : null;
        } catch (e) {
            console.error("Failed to load prop firm settings", e);
            return null;
        }
    };

    const initialState = loadState() || {
        isEnabled: false,
        startingBalance: 10000,   // Account size in $
        maxLossPercent: 10,       // Max total drawdown as % of starting balance (e.g. 10%)
        dailyLossPercent: 5,      // Max daily loss as % of starting balance (e.g. 5%)
        profitTargetPercent: 8,   // Profit target as % of starting balance (e.g. 8%)
    };

    const [settings, setSettings] = useState(initialState);

    useEffect(() => {
        localStorage.setItem('prop_firm_settings_v2', JSON.stringify(settings));
    }, [settings]);

    const togglePropFirmMode = () => {
        setSettings(prev => ({ ...prev, isEnabled: !prev.isEnabled }));
    };

    const updateSettings = (newSettings) => {
        setSettings(prev => ({ ...prev, ...newSettings }));
    };

    return (
        <PropFirmContext.Provider value={{
            isEnabled: settings.isEnabled,
            settings,
            togglePropFirmMode,
            updateSettings
        }}>
            {children}
        </PropFirmContext.Provider>
    );
};
